import {EventEmitter, Injectable, Output} from '@angular/core';

@Injectable()
export class UserSearchBoxService {

  @Output() searchStringChanged = new EventEmitter<string>();

  constructor() { }

  notifySearchStringChanged(searchString : string) {
    this.searchStringChanged.emit(searchString);
  }

}
